/* ============================================================================
 * assets/durii-configurador.js  ·  Durii Editorial  ·  06/09/2026 · 09/09/2026
 *
 * La ficha de «Arma tu pack» (sections/durii-configurador.liquid).
 *
 * LO QUE HACE, Y NADA MÁS
 *
 *   1. El cliente elige portadas en la rejilla. Dos como mucho: la tercera
 *      sustituye a la más antigua. Cada portada elegida lleva el número del
 *      hueco que ocupa (1 o 2).
 *   2. Con dos elegidas, ORDENA la pareja como el generador —título sin
 *      acentos y en minúsculas, `bin/configurador.py:clave()`—, busca el id
 *      del valor de opción de cada una y pide ESTA MISMA sección a Shopify
 *      con `?option_values=<a>,<b>&section_id=<id>` (Section Rendering API).
 *   3. Shopify devuelve la sección con la variante resuelta —precio, si se
 *      puede comprar, y el formulario de añadir de Pipeline ya montado—, y
 *      aquí solo se cambia el bloque `[data-durii-compra]` por el nuevo.
 *   4. Desde el 09/09, los FILTROS: género (chips de la cabecera), intención
 *      de lectura (desplegable) y buscador se combinan sobre los atributos
 *      que cada portada trae de Liquid; y un TOPE enseña N portadas y un
 *      botón dice cuántas faltan. Todo en el navegador: ni una petición.
 *
 * EL PRECIO NO SE CALCULA AQUÍ. Viene de Shopify con la variante, que es la
 * única fuente que vale: lo que el navegador manda es QUÉ libros, nunca
 * CUÁNTO. Y el añadir al carrito es el de Pipeline (Alpine inicializa el
 * formulario nuevo al entrar en el DOM), así que el cajón y el evento
 * `theme:cart:change` funcionan sin tocar nada.
 *
 * LOS IDS DE LOS VALORES DE OPCIÓN se leen del JSON que la sección deja en la
 * página. Cambian solos (06/09), así que no se guardan en ningún sitio.
 * ==========================================================================*/
(function () {
  'use strict';

  // El mismo orden canónico que `clave()` en el generador: NFKD, fuera las
  // marcas combinantes, minúsculas. Si esto y aquello dejaran de coincidir,
  // una pareja se pediría al revés y saldría «no disponible».
  function clave(titulo) {
    return String(titulo || '').normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().trim();
  }

  function iniciar(raiz) {
    if (raiz.dataset.duriiCfgListo === '1') return;
    raiz.dataset.duriiCfgListo = '1';

    var valores;
    try {
      valores = JSON.parse(raiz.querySelector('[data-durii-cfg-valores]').textContent);
    } catch (e) {
      console.warn('durii-configurador: sin ids de valores de opción', e);
      return;
    }

    var sectionId = raiz.dataset.sectionId;
    var compra = raiz.querySelector('[data-durii-compra]');
    var plantillaVacia = raiz.querySelector('template[data-durii-cfg-vacio]');
    var buscador = raiz.querySelector('[data-durii-cfg-busca]');
    var sinResultados = raiz.querySelector('[data-durii-cfg-sin-resultados]');
    var cuenta = raiz.querySelector('[data-durii-cfg-cuenta]');
    var masCaja = raiz.querySelector('[data-durii-cfg-mas]');
    var masBoton = raiz.querySelector('[data-durii-cfg-vermas]');
    var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-durii-cfg-genero]'));
    var intencionCaja = raiz.querySelector('[data-durii-cfg-intencion-caja]');
    var intencionSelect = raiz.querySelector('[data-durii-cfg-intencion]');
    var libros = Array.prototype.slice.call(raiz.querySelectorAll('[data-durii-cfg-libro]'));
    var tiles = Array.prototype.slice.call(raiz.querySelectorAll('[data-durii-cfg-elegir]'));
    var txt = {
      calculando: raiz.dataset.txtCalculando || '…',
      vacio: raiz.dataset.txtVacio || '',
      uno: raiz.dataset.txtUno || '',
      noDisponible: raiz.dataset.txtNoDisponible || '',
      cuentaUno: raiz.dataset.txtCuentaUno || '',
      cuentaVarios: raiz.dataset.txtCuentaVarios || '',
      verMas: raiz.dataset.txtVerMas || '[n]'
    };
    var tope = parseInt(raiz.dataset.visibles, 10) || 0;

    // ── los filtros ──────────────────────────────────────────────────────

    var filtro = { genero: '', intencion: '', busca: '', expandido: false };

    function intencionesDe(li) {
      var s = li.dataset.intencion || '';
      return s ? s.split('|') : [];
    }

    function casa(li) {
      if (filtro.genero && li.dataset.genero !== filtro.genero) return false;
      if (filtro.intencion && intencionesDe(li).indexOf(filtro.intencion) < 0) return false;
      if (filtro.busca && clave(li.dataset.busca).indexOf(filtro.busca) < 0) return false;
      return true;
    }

    // Aplica los tres filtros y el tope de una sola pasada. El buscador
    // levanta el tope: quien busca quiere ver todo lo que casa.
    function aplicarFiltros() {
      var vistos = 0, casan = 0;
      var sinTope = filtro.expandido || !!filtro.busca || tope <= 0;
      libros.forEach(function (li) {
        var ok = casa(li);
        if (ok) casan++;
        var visible = ok && (sinTope || vistos < tope);
        if (visible) vistos++;
        li.hidden = !visible;
      });
      if (sinResultados) sinResultados.hidden = casan > 0;
      if (cuenta) {
        cuenta.textContent = casan + ' ' + (casan === 1 ? txt.cuentaUno : txt.cuentaVarios);
      }
      var faltan = casan - vistos;
      if (masCaja) masCaja.hidden = faltan <= 0;
      if (masBoton) masBoton.textContent = txt.verMas.replace('[n]', String(faltan));
    }

    function pintarChips() {
      var total = 0;
      var porGenero = {};
      libros.forEach(function (li) {
        total++;
        var g = li.dataset.genero || '';
        porGenero[g] = (porGenero[g] || 0) + 1;
      });
      chips.forEach(function (chip) {
        var g = chip.dataset.duriiCfgGenero || '';
        var n = g ? (porGenero[g] || 0) : total;
        var caja = chip.querySelector('[data-durii-cfg-chip-n]');
        if (caja) caja.textContent = n ? String(n) : '';
        chip.hidden = !n;
      });
    }

    function elegirGenero(genero) {
      filtro.genero = genero;
      filtro.expandido = false;
      chips.forEach(function (chip) {
        var activo = (chip.dataset.duriiCfgGenero || '') === genero;
        chip.classList.toggle('is-activo', activo);
        chip.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      aplicarFiltros();
    }

    // El desplegable de intención se rellena con lo que de verdad llevan
    // los libros, de más a menos frecuente; si no hay ninguna, no se enseña.
    function pintarIntenciones() {
      if (!intencionSelect || !intencionCaja) return;
      var cuentas = {};
      libros.forEach(function (li) {
        intencionesDe(li).forEach(function (i) { cuentas[i] = (cuentas[i] || 0) + 1; });
      });
      var lista = Object.keys(cuentas).sort(function (a, b) {
        return (cuentas[b] - cuentas[a]) || a.localeCompare(b, 'es');
      });
      lista.forEach(function (i) {
        var op = document.createElement('option');
        op.value = i;
        op.textContent = i;
        intencionSelect.appendChild(op);
      });
      intencionCaja.hidden = lista.length === 0;
    }

    // ── la elección ──────────────────────────────────────────────────────

    // Los elegidos, en orden de elección. Al cargar con `?option_values=…`
    // la sección ya trae dos tiles pulsados: se parte de ahí.
    var elegidos = tiles
      .filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })
      .map(function (b) { return b.dataset.titulo; });
    var peticion = 0;

    function tileDe(titulo) {
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i].dataset.titulo === titulo) return tiles[i];
      }
      return null;
    }

    function pintarTiles() {
      tiles.forEach(function (b) {
        var pos = elegidos.indexOf(b.dataset.titulo);
        b.setAttribute('aria-pressed', pos >= 0 ? 'true' : 'false');
        var marca = b.querySelector('[data-durii-cfg-marca]');
        if (marca) {
          if (pos >= 0) marca.setAttribute('data-orden', String(pos + 1));
          else marca.removeAttribute('data-orden');
        }
      });
    }

    // Rellena los dos huecos del resumen con lo elegido, clonando la portada
    // del tile. Vale sobre el bloque vacío y sobre el que devuelve Shopify.
    function pintarSlots() {
      var slots = compra.querySelectorAll('[data-durii-cfg-slot]');
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var titulo = elegidos[i];
        var portada = slot.querySelector('[data-durii-cfg-slot-portada]');
        var texto = slot.querySelector('[data-durii-cfg-slot-titulo]');
        var quitar = slot.querySelector('[data-durii-cfg-quitar]');
        if (titulo) {
          var tile = tileDe(titulo);
          var img = tile ? tile.querySelector('img') : null;
          slot.setAttribute('data-lleno', '');
          slot.dataset.titulo = titulo;
          if (portada && img && !portada.querySelector('img')) {
            var copia = img.cloneNode(true);
            copia.removeAttribute('loading');
            copia.removeAttribute('sizes');
            copia.className = 'durii-cfg__img';
            portada.textContent = '';
            portada.appendChild(copia);
          }
          if (texto) texto.textContent = titulo;
          if (quitar) {
            quitar.hidden = false;
            quitar.setAttribute('aria-label', 'Quitar ' + titulo);
          }
        } else {
          slot.removeAttribute('data-lleno');
          delete slot.dataset.titulo;
          if (portada) portada.textContent = '';
          if (texto) texto.textContent = texto.dataset.vacio || '';
          if (quitar) quitar.hidden = true;
        }
      }
    }

    function ponerVacio() {
      if (plantillaVacia) {
        compra.innerHTML = plantillaVacia.innerHTML;
      }
      var resumen = compra.querySelector('[data-durii-cfg-resumen]');
      var precio = compra.querySelector('[data-durii-cfg-precio]');
      if (elegidos.length === 1) {
        if (resumen) resumen.setAttribute('data-estado', 'uno');
        if (precio) precio.textContent = txt.uno || txt.vacio;
      } else {
        if (resumen) resumen.setAttribute('data-estado', 'vacio');
        if (precio) precio.textContent = txt.vacio;
      }
      pintarSlots();
    }

    /* Cuando la pareja NO se puede resolver —la Section Rendering API falla, o
       un título no está entre los valores de opción— el panel NO puede quedarse
       con la pareja anterior. Medido el 09/09 rompiendo la API a propósito: el
       panel seguía enseñando los dos libros viejos, `input[name=id]` seguía
       llevando SU variante y el botón NO estaba apagado, así que se podía
       añadir al carrito una pareja distinta de la elegida. Es la familia de
       fallo que el CLAUDE.md llama «me ha llegado otra talla»: un componente
       auxiliar que se queda con su propio estado.
       Se restaura la plantilla sin pareja, que no trae formulario —y con él se
       va la variante vieja— y cuyo botón nace apagado; y `pintarSlots()` pinta
       los libros que SÍ están elegidos, para que el panel diga la verdad. */
    function ponerNoDisponible() {
      if (plantillaVacia) {
        compra.innerHTML = plantillaVacia.innerHTML;
      }
      compra.removeAttribute('data-cargando');
      var resumen = compra.querySelector('[data-durii-cfg-resumen]');
      var precio = compra.querySelector('[data-durii-cfg-precio]');
      if (resumen) resumen.setAttribute('data-estado', 'no-disponible');
      if (precio) precio.textContent = txt.noDisponible;
      pintarSlots();
    }

    function idsDe(t1, t2) {
      var a = t1, b = t2;
      if (clave(a) > clave(b)) { a = t2; b = t1; }
      var ia = valores.primero && valores.primero[a];
      var ib = valores.segundo && valores.segundo[b];
      return (ia && ib) ? [ia, ib] : null;
    }

    function urlDe(ids) {
      var u = new URL(window.location.href);
      u.searchParams.delete('variant');
      u.searchParams.set('option_values', ids.join(','));
      return u;
    }

    function resolver() {
      var ids = idsDe(elegidos[0], elegidos[1]);
      var precio = compra.querySelector('[data-durii-cfg-precio]');
      if (!ids) {
        // Un título que no está entre los valores de opción: no hay pareja.
        ponerNoDisponible();
        return;
      }
      var mia = ++peticion;
      compra.setAttribute('data-cargando', '');
      if (precio) precio.textContent = txt.calculando;

      var u = urlDe(ids);
      var visible = u.toString();
      u.searchParams.set('section_id', sectionId);

      fetch(u.toString(), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (mia !== peticion) return;   // llegó tarde: ya hay otra pareja
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-durii-compra]');
          if (!nuevo) throw new Error('la sección no trae [data-durii-compra]');
          compra.innerHTML = nuevo.innerHTML;
          compra.removeAttribute('data-cargando');
          pintarSlots();
          try { window.history.replaceState(null, '', visible); } catch (e) { /* sin historial, sin drama */ }
        })
        .catch(function (e) {
          if (mia !== peticion) return;
          console.warn('durii-configurador:', e);
          ponerNoDisponible();
        });
    }

    function actualizar() {
      pintarTiles();
      if (elegidos.length === 2) {
        resolver();
      } else {
        peticion++;                       // anula cualquier petición en vuelo
        ponerVacio();
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.delete('option_values');
          u.searchParams.delete('variant');
          try { window.history.replaceState(null, '', u.toString()); } catch (e) { /* nada */ }
        }
      }
    }

    function alternar(titulo) {
      var i = elegidos.indexOf(titulo);
      if (i >= 0) {
        elegidos.splice(i, 1);
      } else {
        elegidos.push(titulo);
        if (elegidos.length > 2) elegidos.shift();   // la tercera sustituye a la más antigua
      }
      actualizar();
    }

    raiz.addEventListener('click', function (ev) {
      var tile = ev.target.closest('[data-durii-cfg-elegir]');
      if (tile && raiz.contains(tile)) {
        if (tile.disabled) return;
        alternar(tile.dataset.titulo);
        return;
      }
      var quitar = ev.target.closest('[data-durii-cfg-quitar]');
      if (quitar && compra.contains(quitar)) {
        var slot = quitar.closest('[data-durii-cfg-slot]');
        var titulo = slot && slot.dataset.titulo;
        if (titulo && elegidos.indexOf(titulo) >= 0) alternar(titulo);
        return;
      }
      var chip = ev.target.closest('[data-durii-cfg-genero]');
      if (chip && raiz.contains(chip)) {
        elegirGenero(chip.dataset.duriiCfgGenero || '');
        return;
      }
      var mas = ev.target.closest('[data-durii-cfg-vermas]');
      if (mas && raiz.contains(mas)) {
        filtro.expandido = true;
        aplicarFiltros();
      }
    });

    if (buscador) {
      buscador.addEventListener('input', function () {
        filtro.busca = clave(buscador.value);
        aplicarFiltros();
      });
    }

    if (intencionSelect) {
      intencionSelect.addEventListener('change', function () {
        filtro.intencion = intencionSelect.value || '';
        filtro.expandido = false;
        aplicarFiltros();
      });
    }

    // El estado inicial: si la página llegó con la pareja resuelta, los slots
    // ya vienen pintados por Liquid; si no, se deja el bloque vacío tal cual.
    pintarChips();
    pintarIntenciones();
    aplicarFiltros();
    pintarTiles();
    if (elegidos.length && elegidos.length < 2) actualizar();
  }

  function arrancar() {
    var raices = document.querySelectorAll('[data-durii-configurador]');
    for (var i = 0; i < raices.length; i++) iniciar(raices[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  // En el editor de temas la sección se vuelve a pintar entera.
  document.addEventListener('shopify:section:load', arrancar);
})();
